<ng-container *transloco="let _t">

<h3>{{ _t(data.title) }}</h3>
<p>{{ _t(data.message) }}</p>
<button type="button" mat-raised-button color="warn" class="col-5" id="btn-no"
    (click)="dialogRef.close(false)">{{ _t('NO') }}</button>
<button type="button" mat-raised-button color="basic" class="col-5" id="btn-yes"
style="float: right"
    (click)="dialogRef.close(true)">{{ _t('YES') }}</button>

</ng-container>